// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qa-8";
export var editMode = "_qa-3";
export var headerRow = "_qa-a";
export var headerTitle = "_qa-b";
export var product = "_qa-1";
export var productDetails = "_qa-5";
export var productDivider = "_qa-7";
export var productImage = "_qa-2";
export var productInfo = "_qa-4";
export var productTitle = "_qa-6";
export var strikethrough = "_qa-9";
export var upsellProductsCard = "_qa-0";